/* global axios */
import ApiClient from './ApiClient';

class AgentConfigAPI extends ApiClient {
  constructor() {
    super('agent_configs', { accountScoped: true });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  getPublished(id) {
    return axios.get(`${this.url}/${id}/published`);
  }
}

export default new AgentConfigAPI();
